import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.map.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "preloader",
  id: "preloader"
};
const _hoisted_2 = {
  class: "videoBg"
};
const _hoisted_3 = {
  key: 0,
  autoplay: "",
  muted: "",
  loop: "",
  style: {
    "width": "100%",
    "height": "100%",
    "object-fit": "cover"
  }
};
const _hoisted_4 = {
  class: "animated delay fadeInUpBig",
  style: {
    "position": "absolute",
    "right": "20px",
    "bottom": "20px",
    "font-size": "12px",
    "line-height": "400%",
    "text-align": "center",
    "color": "#eee",
    "z-index": "99",
    "cursor": "pointer"
  }
};
const _hoisted_5 = {
  class: "page",
  id: "page",
  style: {
    "display": "none"
  }
};
const _hoisted_6 = {
  class: "rd-navbar-wrap rd-navbar-wrap-absolute"
};
const _hoisted_7 = {
  class: "rd-navbar rd-navbar-line"
};
const _hoisted_8 = {
  class: "navbar-container"
};
const _hoisted_9 = {
  class: "navbar-cell"
};
const _hoisted_10 = {
  class: "navbar-panel"
};
const _hoisted_11 = {
  class: "navbar-logo",
  id: "navbar-logo"
};
const _hoisted_12 = {
  class: "navbar-cell"
};
const _hoisted_13 = {
  class: "navbar-navigation rd-navbar-nav"
};
const _hoisted_14 = {
  class: "navbar-navigation-root-item"
};
const _hoisted_15 = {
  class: "navbar-navigation-root-item"
};
const _hoisted_16 = {
  class: "navbar-navigation-dropdown rd-navbar-dropdown"
};
const _hoisted_17 = {
  class: "navbar-navigation-dropdown-item"
};
const _hoisted_18 = {
  class: "navbar-navigation-dropdown-item"
};
const _hoisted_19 = {
  class: "navbar-navigation-dropdown-item"
};
const _hoisted_20 = {
  class: "navbar-navigation-dropdown-item"
};
const _hoisted_21 = {
  class: "navbar-navigation-root-item"
};
const _hoisted_22 = {
  class: "navbar-navigation-root-item"
};
const _hoisted_23 = {
  class: "navbar-navigation-root-item"
};
const _hoisted_24 = {
  class: "navbar-navigation-root-item"
};
const _hoisted_25 = {
  class: "navbar-navigation-root-item"
};
const _hoisted_26 = {
  class: "navbar-cell"
};
const _hoisted_27 = {
  class: "navbar-subpanel"
};
const _hoisted_28 = {
  class: "navbar-subpanel-item"
};
const _hoisted_29 = {
  class: "navbar-contact"
};
const _hoisted_30 = {
  class: "list list-sm"
};
const _hoisted_31 = {
  class: "list-item"
};
const _hoisted_32 = {
  class: "link link-inherit-primary big2"
};
const _hoisted_33 = {
  class: "list-item"
};
const _hoisted_34 = {
  class: "link link-inherit-primary"
};
const _hoisted_35 = {
  class: "list-item"
};
const _hoisted_36 = {
  class: "intro intro-line context-dark"
};
const _hoisted_37 = {
  class: "swiper-container swiper-numbered",
  "data-swiper": ""
};
const _hoisted_38 = {
  class: "swiper-wrapper"
};
const _hoisted_39 = {
  class: "intro-line-container"
};
const _hoisted_40 = {
  class: "container"
};
const _hoisted_41 = {
  class: "row"
};
const _hoisted_42 = {
  class: "col-md-10"
};
const _hoisted_43 = {
  class: "text-decorated text-decorated-primary-light",
  style: {
    "color": "white"
  }
};
const _hoisted_44 = {
  class: "section-double-2"
};
const _hoisted_45 = {
  class: "section-double-top"
};
const _hoisted_46 = {
  class: "container"
};
const _hoisted_47 = {
  class: "layout layout-2"
};
const _hoisted_48 = {
  class: "layout-content bg-100",
  "data-animate": "{\"class\":\"fadeInUpBig\",\"delay\":\".2s\"}"
};
const _hoisted_49 = {
  class: "flex-column"
};
const _hoisted_50 = {
  class: "row row-6 row-offset-custom-1"
};
const _hoisted_51 = {
  class: "list list-divided h6"
};
const _hoisted_52 = {
  "data-animate": "{\"class\":\"slideInUp\"}",
  style: {
    "display": "flex",
    "justify-content": "flex-end",
    "margin-top": "20px"
  }
};
const _hoisted_53 = {
  class: "section-md context-dark bg-darkest section-double-bottom"
};
const _hoisted_54 = {
  class: "container"
};
const _hoisted_55 = {
  class: "row row-30 row-offset-md"
};
const _hoisted_56 = {
  class: "col-12 col-md-4"
};
const _hoisted_57 = {
  class: "counter counter-bordered"
};
const _hoisted_58 = {
  class: "counter-value"
};
const _hoisted_59 = {
  "data-counter": ""
};
const _hoisted_60 = {
  class: "col-12 col-md-4"
};
const _hoisted_61 = {
  class: "counter counter-bordered"
};
const _hoisted_62 = {
  class: "counter-value"
};
const _hoisted_63 = {
  "data-counter": ""
};
const _hoisted_64 = {
  class: "col-12 col-md-4"
};
const _hoisted_65 = {
  class: "counter counter-bordered"
};
const _hoisted_66 = {
  class: "counter-value"
};
const _hoisted_67 = {
  "data-counter": ""
};
const _hoisted_68 = {
  class: "section-md bg-transparent"
};
const _hoisted_69 = {
  class: "container"
};
const _hoisted_70 = {
  class: "swiper-carousel"
};
const _hoisted_71 = {
  class: "swiper-container",
  "data-swiper": "{\"breakpoints\":{\"576\":{\"slidesPerView\":2,\"spaceBetween\":15},\"768\":{\"slidesPerView\":3,\"spaceBetween\":30}},\"loop\":false,\"pagination\":{\"type\":\"custom\"}}"
};
const _hoisted_72 = {
  class: "swiper-wrapper"
};
const _hoisted_73 = {
  class: "post post-shadow"
};
const _hoisted_74 = {
  class: "post-media"
};
const _hoisted_75 = ["src"];
const _hoisted_76 = {
  class: "post-content"
};
const _hoisted_77 = {
  class: "text-divider"
};
const _hoisted_78 = {
  class: ""
};
const _hoisted_79 = {
  "data-animate": "{\"class\":\"slideInUp\"}",
  style: {
    "display": "flex",
    "justify-content": "flex-end",
    "margin-top": "20px"
  }
};
const _hoisted_80 = {
  class: "section-sm bg-100 text-center"
};
const _hoisted_81 = {
  class: "container"
};
const _hoisted_82 = {
  "data-animate": "{\"class\":\"fadeInUpBig\",\"delay\":\".3s\"}",
  class: "owl-carousel owl-vertical-center owl-content-1",
  "data-owl": "{\"dots\":true}",
  "data-items": "1",
  "data-sm-items": "3",
  "data-md-items": "4",
  "data-lg-items": "4"
};
const _hoisted_83 = ["src"];
import { ref, onMounted, watch, computed } from 'vue';
import { bannerList as bannerListHttp, lawyersList as lawyersListHttp, addressList as addressListHttp } from '@/api/home';
import { territoryList as territoryListHttp } from '@/api/territory';
import { aboutInfo } from '@/api/about';
export default {
  __name: 'Home',
  setup(__props) {
    const path = computed(() => {
      return process.env.VUE_APP_BASE_ADDRESS;
    });
    const isMobile = computed(() => {
      return navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i);
    });

    // 专业领域
    const territoryList = ref([[], []]);
    const getTerritory = async () => {
      const data = await territoryListHttp();
      territoryList.value[0] = data.slice(0, 5);
      territoryList.value[1] = data.slice(5, 10);
    };

    // 数据
    const lawyersNum = ref(459);
    const fensuoNum = ref(6);
    const servicesNum = ref(300);

    // 律师
    const lawyerList = ref([]);
    const getLawyer = async (page = 1) => {
      const {
        list,
        total,
        total_count
      } = await lawyersListHttp({
        page,
        pageSize: 10
      });
      // lawyersNum.value = total_count;
      if (list?.length > 0) {
        for (const item of list) {
          if (!item.avatar.startsWith('http')) item.avatar = path.value + item.avatar;
        }
        lawyerList.value = list;
      }
    };

    // 总部
    const centerInfo = ref({
      city: '石家庄总部',
      address: '河北省石家庄市桥西区石铜路11号冀华律师楼',
      phone: '0311-85288005',
      email: 'jihua666666@163.com'
    });
    const getAddress = async () => {
      const data = await addressListHttp();
      if (data?.length > 0) {
        const centerData = data.find(item => item.city.includes('石家庄'));
        if (centerData) {
          centerInfo.value = centerData;
          fensuoNum.value = data.length - 1;
        }
      }
    };
    const bannerList = ref([]);
    const getBanner = async () => {
      const data = await bannerListHttp({
        type: 'home'
      });
      if (data?.length > 0) {
        for (const item of data) {
          if (!item.src.startsWith('http')) item.src = path.value + item.src;
        }
        bannerList.value = data;
      }
    };
    const honourList = ref([]);
    const getHonour = async () => {
      const data = await aboutInfo({
        type: 'honour'
      });
      honourList.value = data.map(e => !e.startsWith('http') ? path.value + e : e);
    };
    function closeLoad() {
      if (!window.indexLoad) {
        console.log('click首页资源还没有记载成功');
        return false;
      }
      window.isCloseLoading = true;
      document.getElementById('page').style.display = 'block';
      document.getElementById('page').classList.add('page-revealed');
      document.getElementById('preloader').classList.add('animated', 'fadeOutUpBig');
      window.dispatchEvent(new Event('resize'));
      document.getElementById('open').style.display = 'none';
      setTimeout(() => {
        let x1 = document.getElementById('navbar-logo').offsetLeft;
        let y1 = document.getElementById('navbar-logo').offsetTop;
        document.getElementById('loadingLogo').style.left = x1 + 'px';
        document.getElementById('loadingLogo').style.top = y1 + 'px';
        document.getElementById('loadingLogo').style.width = '180px';
        document.getElementById('loadingLogo').style.height = '45.56px';
        document.getElementById('loadingLogo').style.marginTop = '0px';
        document.getElementById('loadingLogo').style.marginLeft = '0px';
      }, 30);
      setTimeout(() => {
        document.getElementById('loadingLogo').style.display = 'none';
        document.getElementById('navLogo').style.opacity = 1;
      }, 1030);
    }
    let time = 3000;
    let laodingTxt = ref('正在加载中...');
    function closeLoadMintor() {
      if (!window.indexLoad) {
        console.log('setTimeout首页资源还没有记载成功');
        time = 4000;
        laodingTxt.value = '请稍等...';
        setTimeout(() => {
          closeLoadMintor();
        }, 1000);
        return false;
      }
      laodingTxt.value = '点击任意位置进入网站...';
      setTimeout(function () {
        if (!window.isCloseLoading) {
          closeLoad();
        }
      }, time);
    }
    const indexLoad = ref(false);
    onMounted(() => {
      getHonour();
      getBanner();
      getAddress();
      getTerritory();
      getLawyer(1);
      window.indexLoad = false;
      window.isCloseLoading = false;
      console.log('初始设置');
      if (document.getElementById('page') && document.getElementById('page') && document.getElementById('preloader')) {
        document.getElementById('open').onclick = function () {
          console.log('点击事件');
          closeLoad();
        };
        closeLoadMintor();
      }
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock(_Fragment, null, [_cache[41] || (_cache[41] = _createElementVNode("div", {
        id: "open"
      }, null, -1)), _cache[42] || (_cache[42] = _createElementVNode("img", {
        class: "animated fadeInUpBig",
        id: "loadingLogo",
        src: "/images/logo.png"
      }, null, -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [!isMobile.value ? (_openBlock(), _createElementBlock("video", _hoisted_3, _cache[0] || (_cache[0] = [_createElementVNode("source", {
        src: "/images/bg2.mp4",
        type: "video/mp4"
      }, null, -1), _createTextVNode(" 您的浏览器不支持视频标签。 ")]))) : _createCommentVNode("", true)]), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "gifBg"
      }, [_createElementVNode("img", {
        style: {
          "width": "100%",
          "height": "100%",
          "object-fit": "cover"
        },
        src: "/images/bg.jpg"
      })], -1)), _cache[2] || (_cache[2] = _createElementVNode("div", {
        id: "overlay",
        style: {
          "position": "fixed",
          "background-color": "rgba(2, 2, 2, .6)",
          "bottom": "0",
          "left": "0",
          "top": "0",
          "right": "0"
        }
      }, null, -1)), _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(laodingTxt)), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("header", _hoisted_6, [_createElementVNode("nav", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_cache[4] || (_cache[4] = _createElementVNode("button", {
        class: "navbar-switch linearicons-menu",
        "data-multi-switch": "{\"targets\":\".rd-navbar\",\"scope\":\".rd-navbar\",\"isolate\":\"[data-multi-switch]\"}"
      }, null, -1)), _createElementVNode("div", _hoisted_11, [_createVNode(_component_router_link, {
        class: "navbar-logo-link",
        to: "/"
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createElementVNode("img", {
          class: "navbar-logo-default",
          id: "navLogo",
          style: {
            "opacity": "0"
          },
          src: "/images/logo.png",
          alt: "冀华律所",
          width: "180",
          height: "41"
        }, null, -1)])),
        _: 1
      })])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("ul", _hoisted_13, [_createElementVNode("li", _hoisted_14, [_createVNode(_component_router_link, {
        class: "navbar-navigation-root-link",
        to: "/"
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("首页")])),
        _: 1
      })]), _createElementVNode("li", _hoisted_15, [_cache[11] || (_cache[11] = _createElementVNode("a", {
        class: "navbar-navigation-root-link",
        href: "javascript:;"
      }, "关于冀华", -1)), _createElementVNode("ul", _hoisted_16, [_cache[10] || (_cache[10] = _createElementVNode("li", {
        class: "navbar-navigation-back"
      }, [_createElementVNode("button", {
        class: "navbar-navigation-back-btn"
      }, "返回")], -1)), _createElementVNode("li", _hoisted_17, [_createVNode(_component_router_link, {
        class: "navbar-navigation-dropdown-link",
        to: "/about?type=introduction"
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("冀华简介")])),
        _: 1
      })]), _createElementVNode("li", _hoisted_18, [_createVNode(_component_router_link, {
        class: "navbar-navigation-dropdown-link",
        to: "/about?type=organization"
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("组织机构")])),
        _: 1
      })]), _createElementVNode("li", _hoisted_19, [_createVNode(_component_router_link, {
        class: "navbar-navigation-dropdown-link",
        to: "/about?type=honour"
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("资质荣誉")])),
        _: 1
      })]), _createElementVNode("li", _hoisted_20, [_createVNode(_component_router_link, {
        class: "navbar-navigation-dropdown-link",
        to: "/about?type=service"
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("服务理念")])),
        _: 1
      })])])]), _createElementVNode("li", _hoisted_21, [_createVNode(_component_router_link, {
        class: "navbar-navigation-root-link",
        to: "/territory"
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("冀华专业")])),
        _: 1
      })]), _createElementVNode("li", _hoisted_22, [_createVNode(_component_router_link, {
        class: "navbar-navigation-root-link",
        to: "/lawyers"
      }, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("冀华精英")])),
        _: 1
      })]), _createElementVNode("li", _hoisted_23, [_createVNode(_component_router_link, {
        class: "navbar-navigation-root-link",
        to: "/our-cases"
      }, {
        default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("冀华洞见")])),
        _: 1
      })]), _createElementVNode("li", _hoisted_24, [_createVNode(_component_router_link, {
        class: "navbar-navigation-root-link",
        to: "/service"
      }, {
        default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("冀华伙伴")])),
        _: 1
      })]), _createElementVNode("li", _hoisted_25, [_createVNode(_component_router_link, {
        class: "navbar-navigation-root-link",
        to: "/contact-us"
      }, {
        default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("联系我们")])),
        _: 1
      })])])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_cache[19] || (_cache[19] = _createElementVNode("span", {
        class: "navbar-contact-text"
      }, "免费咨询", -1)), _cache[20] || (_cache[20] = _createElementVNode("button", {
        class: "navbar-button navbar-contact-btn navbar-contact-btn-rounded linearicons-telephone",
        "data-multi-switch": "{\"targets\":\".rd-navbar\",\"scope\":\".rd-navbar\",\"class\":\"navbar-contact-active\",\"isolate\":\"[data-multi-switch]:not(.rd-navbar-contact-btn)\"}"
      }, null, -1)), _createElementVNode("div", _hoisted_29, [_createElementVNode("ul", _hoisted_30, [_cache[18] || (_cache[18] = _createElementVNode("li", {
        class: "list-item"
      }, [_createElementVNode("h4", {
        class: "text-uppercase text-primary"
      }, "免费咨询")], -1)), _createElementVNode("li", _hoisted_31, [_createElementVNode("a", _hoisted_32, _toDisplayString(centerInfo.value.phone), 1)]), _createElementVNode("li", _hoisted_33, [_createElementVNode("a", _hoisted_34, _toDisplayString(centerInfo.value.email), 1)]), _createElementVNode("li", _hoisted_35, [_createElementVNode("span", null, [_createTextVNode(_toDisplayString(centerInfo.value.address?.slice(0, 7)) + " ", 1), _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)), _createTextVNode(_toDisplayString(centerInfo.value.address?.slice(7)), 1)])])])])])])])])])]), _createElementVNode("section", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bannerList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "swiper-slide",
          key: item.id,
          style: _normalizeStyle({
            'background-image': 'url(' + item.src + ')'
          })
        }, [_createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("p", _hoisted_43, _toDisplayString(item.small_title), 1), _createElementVNode("h1", null, _toDisplayString(item.big_title), 1)])])])])], 4);
      }), 128))]), _cache[21] || (_cache[21] = _createElementVNode("div", {
        class: "swiper-pagination"
      }, null, -1))])]), _cache[40] || (_cache[40] = _createStaticVNode("<section class=\"section-md bg-transparent section-creative-top\" data-v-742315bf><div class=\"container\" data-v-742315bf><div class=\"row\" data-v-742315bf><div class=\"col-md-10 col-lg-12\" data-animate=\"{&quot;class&quot;:&quot;fadeIn&quot;}\" data-v-742315bf><p class=\"big\" data-v-742315bf> 河北冀华律师事务所成立于1996年，系河北省司法厅直属合伙制律师事务所。经过二十多年的发展，冀华所在唐山、定州、赞皇、邯郸、海口、称多设有6个分所，现有执业律师、实习和行政人员459人，系河北省起引领与示范作用的综合性律师事务所，为河北省律师界的“旗舰所”，位居全国“百强所”前列。 </p></div></div></div></section>", 1)), _createElementVNode("section", _hoisted_44, [_createElementVNode("section", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_cache[24] || (_cache[24] = _createElementVNode("div", {
        class: "layout-media bg-image",
        style: {
          "background-image": "url(images/zhuanye.png)"
        },
        "data-animate": "{\"class\":\"fadeInUpBig\"}"
      }, null, -1)), _createElementVNode("div", _hoisted_48, [_cache[23] || (_cache[23] = _createElementVNode("h2", {
        style: {
          "margin-bottom": "20px"
        }
      }, "专业领域", -1)), _createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(territoryList.value, (item, idx) => {
        return _openBlock(), _createElementBlock("div", {
          class: "col-sm-6",
          key: idx
        }, [_createElementVNode("ul", _hoisted_51, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, el => {
          return _openBlock(), _createElementBlock("li", {
            class: "list-item",
            key: el.id
          }, [_createVNode(_component_router_link, {
            to: '/territory?id=' + el.id,
            class: "link link-arrow"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(el.name), 1)]),
            _: 2
          }, 1032, ["to"])]);
        }), 128))])]);
      }), 128))]), _createElementVNode("div", _hoisted_52, [_createVNode(_component_router_link, {
        class: "btn",
        to: "/territory"
      }, {
        default: _withCtx(() => _cache[22] || (_cache[22] = [_createTextVNode("更多")])),
        _: 1
      })])])])])])]), _createElementVNode("section", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_cache[34] || (_cache[34] = _createElementVNode("h2", {
        class: "text-divider"
      }, "业务数据", -1)), _createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_createElementVNode("span", _hoisted_59, _toDisplayString(fensuoNum.value), 1), _cache[25] || (_cache[25] = _createElementVNode("span", {
        class: "counter-unit"
      }, null, -1)), _cache[26] || (_cache[26] = _createElementVNode("span", {
        class: "counter-icon linearicons-umbrella"
      }, null, -1))]), _cache[27] || (_cache[27] = _createElementVNode("div", {
        class: "counter-title"
      }, [_createElementVNode("h6", null, "律师分所")], -1))])]), _createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_createElementVNode("span", _hoisted_63, _toDisplayString(lawyersNum.value), 1), _cache[28] || (_cache[28] = _createElementVNode("span", {
        class: "counter-unit"
      }, null, -1)), _cache[29] || (_cache[29] = _createElementVNode("span", {
        class: "counter-icon linearicons-file-check"
      }, null, -1))]), _cache[30] || (_cache[30] = _createElementVNode("div", {
        class: "counter-title"
      }, [_createElementVNode("h6", null, "执业律师、实习和行政人员")], -1))])]), _createElementVNode("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createElementVNode("span", _hoisted_67, _toDisplayString(servicesNum.value), 1), _cache[31] || (_cache[31] = _createElementVNode("span", {
        class: "counter-unit"
      }, "余家", -1)), _cache[32] || (_cache[32] = _createElementVNode("span", {
        class: "counter-icon linearicons-bookmark2"
      }, null, -1))]), _cache[33] || (_cache[33] = _createElementVNode("div", {
        class: "counter-title"
      }, [_createElementVNode("h6", null, "冀华伙伴")], -1))])])])])])]), _createElementVNode("section", _hoisted_68, [_createElementVNode("div", _hoisted_69, [_cache[38] || (_cache[38] = _createStaticVNode("<div class=\"row row-5 align-items-center\" data-v-742315bf><div class=\"col-md-3\" data-animate=\"{&quot;class&quot;:&quot;fadeIn&quot;}\" data-v-742315bf><h2 class=\"text-divider\" data-v-742315bf>冀华精英</h2></div><div class=\"col-md-9\" data-animate=\"{&quot;class&quot;:&quot;fadeInUpBig&quot;,&quot;delay&quot;:&quot;.2s&quot;}\" data-v-742315bf><p class=\"big\" data-v-742315bf> 冀华律师大多毕业于北京大学、中国政法大学、南开大学、吉林大学、西南政法大学、西北政法大学等知名学府，近半数律师具有硕士、双学士或博士学位，十余名律师兼任高等院校的法学教授、硕士研究生导师，多数律师具有十年以上执业经历，具有良好的职业道德、较高的政治业务素质和较强的执业能力。多年的专业法律服务实践，冀华律师以客户为中心，运用冀华所全部资源为客户排除法律障碍、化解法律风险，为每一位客户提供专业、优质、高效的法律服务。 </p></div></div>", 1)), _createElementVNode("div", _hoisted_70, [_createElementVNode("div", _hoisted_71, [_createElementVNode("div", _hoisted_72, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lawyerList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "swiper-slide",
          key: item.id
        }, [_createElementVNode("div", _hoisted_73, [_createVNode(_component_router_link, {
          to: {
            path: 'team-member',
            query: {
              id: item.id
            }
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_74, [_createElementVNode("img", {
            src: item.avatar,
            alt: "",
            style: {
              "width": "270px",
              "max-height": "344px",
              "object-fit": "cover",
              "object-position": "top"
            }
          }, null, 8, _hoisted_75), _cache[35] || (_cache[35] = _createElementVNode("div", {
            class: "post-hover-btn"
          }, "查看", -1))]), _createElementVNode("div", _hoisted_76, [_createElementVNode("h5", _hoisted_77, _toDisplayString(item.position), 1), _createElementVNode("h5", _hoisted_78, _toDisplayString(item.name) + "律师", 1)])]),
          _: 2
        }, 1032, ["to"])])]);
      }), 128))]), _cache[36] || (_cache[36] = _createStaticVNode("<div class=\"swiper-controls\" data-v-742315bf><div class=\"swiper-pagination\" data-v-742315bf></div><div class=\"swiper-progress\" data-v-742315bf><div class=\"swiper-progress-bar\" data-v-742315bf></div></div><div class=\"swiper-buttons\" data-v-742315bf><div class=\"swiper-button-prev mdi-chevron-left\" data-v-742315bf></div><div class=\"swiper-button-next mdi-chevron-right\" data-v-742315bf></div></div></div>", 1))])]), _createElementVNode("div", _hoisted_79, [_createVNode(_component_router_link, {
        class: "btn",
        to: "/lawyers"
      }, {
        default: _withCtx(() => _cache[37] || (_cache[37] = [_createTextVNode("更多")])),
        _: 1
      })])])]), _createElementVNode("section", _hoisted_80, [_createElementVNode("div", _hoisted_81, [_cache[39] || (_cache[39] = _createElementVNode("h3", {
        "data-animate": "{\"class\":\"fadeIn\"}"
      }, "冀华荣誉", -1)), _createElementVNode("div", _hoisted_82, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(honourList.value, (item, idx) => {
        return _openBlock(), _createElementBlock("img", {
          src: item,
          alt: "",
          style: {
            "object-fit": "fill",
            "width": "270px",
            "height": "180px"
          },
          key: idx
        }, null, 8, _hoisted_83);
      }), 128))])])]), _createVNode(_component_Footer)])], 64);
    };
  }
};